import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface ChatMessage {
  role: string;
  content: string;
}

@Injectable({
  providedIn: 'root'
})
export class ChatService {
  private conversationHistorySubject = new BehaviorSubject<ChatMessage[]>([]);

  addMessage(message: ChatMessage) {
    const currentHistory = this.conversationHistorySubject.value;
    this.conversationHistorySubject.next([...currentHistory, message]);
  }

  getConversationHistory(): Observable<ChatMessage[]> {
    return this.conversationHistorySubject.asObservable();
  }

  clearHistory() {
    this.conversationHistorySubject.next([]);
  }
} 